import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal} from 'src/app/core/auth/principal.service';
import {FinscanEntity} from 'src/app/shared/model/fin-scan-opportunities.model';
import {IVesselScreening,VesselScreening} from 'src/app/shared/model/vessel-screening.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CertificateMySuffixService} from '../certificate-client/certificate-client.service';
import {OrderPipe} from './../../shared/custom-pipe/order.pipe';
import {VesselInformationMySuffixService} from './vessel-information-my-suffix.service';
import { TdisConstants } from 'src/app/shared/constants/tdis-constants';
import { CommonUtils } from 'src/app/shared/util/common-utils';

declare let $: any;


@Component({
    selector: 'jhi-vessel-screening.component',
    templateUrl: './vessel-screening.component.html',
    providers: [
        OrderPipe
    ]
})
export class VesselScreeningComponent implements OnInit {

    readonly TdisConstants = TdisConstants;

    @ViewChild('subRuleInfo') subRuleInfo: ModalDirective;
    @ViewChild('vesselNameModal') vesselNameModal: ModalDirective;
    // canSave:boolean=true;
    _iVesselScreening: IVesselScreening;
    clientList = [];
    policyList:any[] = [];
    VesselScreeningPayload: IVesselScreening;
    imoNumber: number;
    incoterms: string;
    productName: string
    product: string
    clientName: string;
    clientId: number;
    clientType: string
    loadingTypeObj: any;
    loadingTypeList = [];
    isVesselName: boolean = false;
    isClient: boolean = false;
    vesselName: any;
    vesselNameAndImoNumbers = [];
    isVesselSelectedByCheckbox: boolean = false;
    isVesselIMoSelected: boolean = true;
    subRuleInfoMessages = [];
    vesselIMoId: number;
    isSanctionScreeningEnabled = false;
    finscanOppurtunitiesType: string = ''
    clientSelection: any;
    policySelection: any;
    policyNumberWithCompanyName: string
    loadingSettings = {
        singleSelection: true,
        text: 'Select Loading Type',
        allowSearchFilter: true,
        classes: 'myclass custom-class',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen: false
    };

    clientDropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'companyNameOnly',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 6,
        allowSearchFilter: true,
        defaultOpen: false
    };
    policyDropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'policyNumberWithCompanyName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 6,
        allowSearchFilter: true,
        defaultOpen: false
    };
    page = 0;
    // size = 20;
    size = 50;
    private isApiCalled: boolean = true;
    private vesselDataLoaded: boolean = false;
    constructor(private activatedRoute: ActivatedRoute,
        private certificateService: CertificateMySuffixService,
        private vesselInformationMySuffixService: VesselInformationMySuffixService,
        private jhiAlertService: JhiAlertService,
        private orderPipe: OrderPipe,
        private principal: Principal,
        private languageChangeService: LanguageChangeService,

    ) {
        this._iVesselScreening = new VesselScreening();
        this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {

                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
        });
    }

    removeVesselName(imoOrName) {
        if (imoOrName == TdisConstants.MeansOfConveyance.VESSEL) {
            this.vesselNameAndImoNumbers = [];
            this.vesselScreening.imoNumber = null;
            this.isVesselIMoSelected = false;
        } else {
            this.isVesselIMoSelected = true;
            this.vesselScreening.vesselName = null;
        }

    }



    get vesselScreening() {
        return this._iVesselScreening;
    }


    ngOnInit() {
        this.principal.setTitle("Vessel Screening");
        this.clientType = '';
        this.incoterms = ''
        // this.verifyProduct();
        this.productName = TdisConstants.ProductName.MCI;
        this.getLoadingTypeList();

        if (this.principal.authority !== 'CLIENT' && this.principal.authority !== 'CLIENT_STAFF') {
            this.getClientList();
        } else {
            this.isClient=true;
            this.getPolicyDataBasedOnClient(this.principal.getPolicyHolderId())
        }

        this.activatedRoute.queryParamMap.subscribe(params => {
            let routeData = { ...params.keys, ...params };
            console.log(routeData, "routeData");
            //  this.vesselIMoId = params['params'].imoNumberId;
            this.vesselIMoId = this.activatedRoute.snapshot.params['id'];
            if (this.vesselIMoId) {
                this.vesselInformationMySuffixService.findVesselImoInformation(this.vesselIMoId).subscribe(response => {
                    let responseData = response['body'];
                    console.log("responseData", responseData);
                    if(this.VesselScreeningPayload) {
                        this.VesselScreeningPayload = null;
                    }
                    this.VesselScreeningPayload = new VesselScreening();
                    this.VesselScreeningPayload.vesselName = responseData.vesselName;
                    this.VesselScreeningPayload.vesselType = responseData.vesselType;
                    this.VesselScreeningPayload.yearOfBuild = responseData.yearOfBuild;
                    this.VesselScreeningPayload.vesselAge = responseData.vesselAge;
                    this.VesselScreeningPayload.overagePremiumRate = responseData.overagePremiumRate;
                    this.VesselScreeningPayload.vesselStatus = responseData.vesselStatus;
                    this.VesselScreeningPayload.dateOfNextSurvey = responseData.dateOfNextSurvey;
                    this.VesselScreeningPayload.classificationSocietyName = responseData.classificationSocietyName;
                    this.VesselScreeningPayload.product = responseData.product;
                    this.VesselScreeningPayload.imoNumber = responseData.imoNumber;
                    this.VesselScreeningPayload.loadingType = responseData.loadingType;
                    this.VesselScreeningPayload.isFirstClassAsPerPolicyRules = responseData.isFirstClassAsPerPolicyRules;
                    this.VesselScreeningPayload.enableSanctionScreening = responseData.enableSanctionScreening;
                    this.VesselScreeningPayload.enableSanctionScreening = responseData.enableSanctionScreening;
                    this.VesselScreeningPayload.finscanResultStatus = responseData.finscanResultStatus;
                    this.VesselScreeningPayload.policyNo = responseData.policyNo;
                })
            }

        });
        this.isSanctionScreeningEnabled = this.principal.checkForEnableSanctionScreeningForFinscanEntity(FinscanEntity.VESSELS);
        this.finscanOppurtunitiesType = this.principal.checkForFinscanOppurtunitiesType(FinscanEntity.VESSELS);
    }

    previousState() {
        window.history.back();
    }
    search() {

    }

    incotermsChange() {
        this.verifyProduct();
    }

    //
    clientChange() {
        this.verifyProduct();
    }

    verifyProduct() {
        if (this.clientType === TdisConstants.ClientType.Seller) {
            if (this.incoterms === TdisConstants.IncoTerms.CIF) {
                this.productName = TdisConstants.ProductName.MCI;
                this.product = TdisConstants.Product.MARINE_CARGO_INSURANCE;
            } else if (this.incoterms === TdisConstants.IncoTerms.FOB) {
                this.productName = TdisConstants.ProductName.SI;
                this.product = TdisConstants.Product.SELLERS_INTEREST;
            } else if (this.incoterms === TdisConstants.IncoTerms.CFR) {
                this.productName = TdisConstants.ProductName.SI;
                this.product = TdisConstants.Product.SELLERS_INTEREST;
            }
        } else if (this.clientType === TdisConstants.ClientType.Buyer) {
            if (this.incoterms === TdisConstants.IncoTerms.CIF) {
                this.productName = TdisConstants.ProductName.BI;
                this.product = TdisConstants.Product.BUYERS_INTEREST;
            } else if (this.incoterms === TdisConstants.IncoTerms.FOB) {
                this.productName = TdisConstants.ProductName.MCI;
                this.product = TdisConstants.Product.MARINE_CARGO_INSURANCE;

            } else if (this.incoterms === TdisConstants.IncoTerms.CFR) {
                this.productName = TdisConstants.ProductName.MCI;
                this.product = TdisConstants.Product.MARINE_CARGO_INSURANCE;

            }
        }
    }

    getLoadingTypeList() {
        this.certificateService.get('get-loading-type-list/' + TdisConstants.MeansOfConveyance.VESSEL).subscribe(res => {
            // this.loadingTypeList  = res.body['payload'];
            let loadingTypeList = [...res.body['payload']];
            this.loadingTypeList = this.orderPipe.transform(loadingTypeList, 'name', false, true);
        });
    }

    getClientList() {
        this.vesselInformationMySuffixService.getTraderClient("vessel-screening-trader-list").subscribe(res => {
            // this.loadingTypeList  = res.body['payload'];
            this.clientList = res.body;
        });
    }
    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode === 46) {
            return true;
        } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        } else {
            return true;
        }
    }
    save() {

        this.vesselScreening.product = this.product;
        this.vesselScreening.loadingTypeId = null;
        if (this.loadingTypeObj && this.loadingTypeObj.length > 0) {
            this.vesselScreening.loadingTypeId = this.loadingTypeObj[0].id;
        }

        this.vesselScreening.clientId = null;
        if (this.clientId) {
            this.vesselScreening.clientId = this.clientId;
        }

        if(this.policyList.length>0 && this.policySelection!=null && this.policySelection.length>0){
            this.vesselScreening.policyId=this.policySelection[0].id;
        } else {
            this.vesselScreening.policyId=null
        }

        if (this.isVesselName) {
            if (this.vesselScreening.vesselName) {
                if (this.vesselNameAndImoNumbers.length == 1) {
                    let event = {
                        target: {
                            value: this.vesselNameAndImoNumbers[0].imoNumber
                        }
                    }
                    this.changeImoNumber(event);
                    this.onImoSubmit()
                } else {
                    if(this.vesselScreening.vesselName ) {
                        this.getImoNumberByVesselName();
                    }
                    this.showVesselNameModal();
                    // move scroll bar top of the div
                    setTimeout(() => {
                        let myDiv = document.getElementById('focusDiv');
                        myDiv.scrollTop = 0;
                    }, 1000);
                    $(".width-10 input[type='radio']").prop('checked', false)
                }

                return;
            }

        }
        if (!this.vesselScreening.imoNumber && !this.vesselScreening.vesselName) {
            this.jhiAlertService.error("vessel name / imo is required");
            return;
        }
        if (this.isVesselIMoSelected) {
            this.saveVesselScreeningData();
        } else {
            this.getImoNumberByVesselName()
        }
    }

    isVesselPresent: boolean = false;
    saveVesselScreeningData() {
        this.vesselInformationMySuffixService.post("vessel-screening", this.vesselScreening).subscribe(res => {
            this.subRuleInfoMessages = [];
            if(this.VesselScreeningPayload) {
                this.VesselScreeningPayload = null;
            }
            if(res && res.body && res.body.message.length > 0) {
                this.isVesselPresent = false;
                this.subRuleInfoMessages = res.body.message[0];
                this.VesselScreeningPayload = res.body.payload;
            }

            if(this.VesselScreeningPayload && (!this.VesselScreeningPayload.yearOfBuild && !this.VesselScreeningPayload.vesselAge && !this.VesselScreeningPayload.classificationSocietyName && !this.VesselScreeningPayload.vesselStatus && !this.VesselScreeningPayload.dateOfNextSurvey)) {
                this.isVesselPresent = true;
                this.jhiAlertService.error("No Information from the Vessel Database");
            }
            // this.canSave=false;
        }, err => {
            //this.jhiAlertService.error(err.message);
        })
    }
    //getImoNumberData
    getImoNumberByVesselName() {
        this.vesselNameAndImoNumbers = [];
        if (this.vesselScreening.vesselName) {
            this.vesselScreening.vesselName = this.vesselScreening.vesselName.trim();
            this.page = 0;
            // this.size = 20;
            this.size = 50;
            this.getImoNumberDataPageable(this.page, this.size, false);
            // if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
            //     this.getImoNumberDataPageable(this.page, this.size, false);
            // } else {
            //     return;
            // }
            this.vesselDataLoaded = false;
            this.isApiCalled = true;
            /*  this.vesselScreening.vesselName = this.vesselScreening.vesselName.trim()
             this.vesselInformationMySuffixService.findIHSImosByName(this.vesselScreening.vesselName.trim()).subscribe(data => {
                 console.log(data);
                 this.vesselNameAndImoNumbers = data.body;
                 if (this.vesselNameAndImoNumbers.length > 1) {
                     this.showVesselNameModal();
                 } else if (this.vesselNameAndImoNumbers.length == 1) {
                     let event = {
                         target: {
                             value: this.vesselNameAndImoNumbers[0].imoNumber
                         }
                     }
                     this.changeImoNumber(event);
                     this.onImoSubmit()
                 } else {
                     this.showVesselNameModal();
                 }
             }, err => {
             }) */
        }
    }


    // this.getImoNumberDataPageable(this.page,this.size,false);
    ihsTotalCount: number = 0;
    getImoNumberDataPageable(page: number, size: number, flag: boolean) {
        this.vesselInformationMySuffixService.post("ihs-vessel-informations-detail/?page=" + page + "&size=" + size, { name: this.vesselScreening.vesselName }).subscribe(res => {
            let body = res.body;
            if(res && res.headers) {
                const xTotalCount = res.headers.get('X-Total-Count');
                if(typeof xTotalCount === 'string') {
                  this.ihsTotalCount = parseInt(xTotalCount);
                } else {
                  this.ihsTotalCount = xTotalCount;
                }
            }
            if (body && body.length > 0) {
                // this.vesselNameAndImoNumbers = [...body, ...this.vesselNameAndImoNumbers];
                this.vesselNameAndImoNumbers = [...this.vesselNameAndImoNumbers, ...body];
            } else {
                this.vesselDataLoaded = true;
            }

            if (flag) {
                this.isApiCalled = true;
            }
        }, err => { });
    }
    vesselNameIndexTrack(index: number) {
        return index;
    }
    onVesselModelScroll() {
        if (this.isApiCalled && !this.vesselDataLoaded) {
            this.isApiCalled = false;
            this.page++;
            if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
                this.getImoNumberDataPageable(this.page, this.size, true);
            } else {
                return;
            }
        }
    }
    hideSubRuleInfo() {
        this.subRuleInfo.hide();
        //this.previousState();
    }

    showSubRuleInfo() {
        // this.subRuleInfo.show();
    }

    hideVesselNameModal() {
        this.isVesselSelectedByCheckbox = false
        this.vesselNameModal.hide();
    }
    showVesselNameModal() {
        this.vesselNameModal.show();
    }

    changeImoNumber(event) {
        this.isVesselSelectedByCheckbox = true;
        console.log(event.target.value);
        this.vesselScreening.imoNumber = event.target.value;

    }
    onImoSubmit() {
        this.hideVesselNameModal();
        this.saveVesselScreeningData();

    }


    onItemSelect(clientSelect) {
        console.log(clientSelect[0]);
        this.clientName = clientSelect[0].companyNameOnly;
        this.clientId = clientSelect[0].id;
        this.getPolicyDataBasedOnClient(this.clientId);
        this.policySelection=null;
    }

   
    onPolicySelect(policySelect) {
        if(CommonUtils.isNil(this.product)) {
            this.product = 'MARINE_CARGO_INSURANCE';
        }
    }

    onPolicyDeSelect() {
        this.policySelection=null;
    }

    onItemDeSelect() {
        console.log("---------------");
        this.clientName = null;
        this.clientId=null;
        this.policySelection=null;
    }

    replaceNumberFeomEnd(str: string) {
        if (str == undefined) return "";
        let s = str.replace(/[\d.-]/g, '');
        return s;
    }

    yearOfBuild(date) {
        if (date && date.length > 4) {
            return date.substring(0, 4);
        }
        return date;
    }


    private getPolicyDataBasedOnClient(clientId) {
        this.vesselInformationMySuffixService.getPolicyOfPolicyHolder(clientId).subscribe((res: any) => {
            this.policyList = res.body;
            this.policyList.forEach((res) => res.policyNumberWithCompanyName = `${res.policyNo} (${res.clientDTO.companyName}) [${res.lineOfBusiness}]`);
        });
    }



}
